import { Navigate, Outlet } from "react-router-dom";
import Loader from "../components/Loader";
import { useAuth } from "./Auth";

export default function ProtectedRoute({ allowedRoles }) {
  const { user, role, loading } = useAuth();

  if (loading) return <Loader />;

  if (!user || !allowedRoles.includes(role)) {
    return <Navigate to='/login' replace />;
  }

  return <Outlet />;
}
